import { useCollection } from '../../context/CollectionContext';

// Default logos for different contexts
const DEFAULT_LOGO_DARK = 'https://customer-assets.emergentagent.com/job_paige-minerals/artifacts/vpfkgbd0_49AE85BE-B9E1-4DE1-83AA-71B73D3A0DC9.png';
const DEFAULT_LOGO_LIGHT = 'https://customer-assets.emergentagent.com/job_paige-minerals/artifacts/adk204an_IMG_4053.png';

const Logo = ({ className = "h-8", variant = "dark" }) => {
    const { siteSettings } = useCollection();
    
    // Use the appropriate logo based on variant
    // For light variant (on dark backgrounds like navy header/footer), use the white/gold logo
    // For dark variant (on light/white backgrounds), use the navy/gold logo
    const logoSrc = variant === "light" 
        ? DEFAULT_LOGO_LIGHT
        : DEFAULT_LOGO_DARK;
    
    return (
        <div className={`flex items-center ${className}`}>
            <img 
                src={logoSrc}
                alt="Paige Minerals"
                className="h-full w-auto object-contain"
            />
        </div>
    );
};

export default Logo;
